var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(90 16 16)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 16C24 11.5813 20.4187 8 16 8C11.5813 8 8 11.5813 8 16C8 20.4187 11.5813 24 16 24C16.0469 24 16.0938 24 16.1406 23.9969V17.7719H14.4219V15.7688H16.1406V14.2937C16.1406 12.5844 17.1844 11.6531 18.7094 11.6531C19.4406 11.6531 20.0688 11.7062 20.25 11.7313V13.5188H19.2C18.3719 13.5188 18.2094 13.9125 18.2094 14.4906V15.7656H20.1938L19.9344 17.7688H18.2094V23.6906C21.5531 22.7312 24 19.6531 24 16Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/Footer-Facebook.2cc133f42039b0086922d91b55846e39.svg";
export { ForwardRef as ReactComponent };